var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 6.66667V10.0008H2.50001V15H1.66667V17.5H15L17.5 17.5008V17.5H18.3333V15H17.5V10.0008H18.3333V6.66667L10 1.66667L1.66667 6.66667ZM5.00001 15V10.0008H6.66667V15H5.00001ZM9.16667 15V10.0008H10.8333V15H9.16667ZM15 15H13.3333V10.0008H15V15ZM11.6667 6.66667C11.6666 6.8856 11.6234 7.10237 11.5396 7.30461C11.4558 7.50684 11.3329 7.69059 11.1781 7.84536C11.0233 8.00012 10.8394 8.12287 10.6372 8.2066C10.4349 8.29033 10.2181 8.33339 9.99917 8.33334C9.78025 8.33328 9.56348 8.29011 9.36124 8.20628C9.159 8.12245 8.97525 7.99961 8.82049 7.84477C8.66572 7.68992 8.54297 7.50612 8.45925 7.30384C8.37552 7.10155 8.33245 6.88476 8.33251 6.66584C8.33262 6.2237 8.50836 5.79972 8.82108 5.48715C9.13379 5.17459 9.55787 4.99906 10 4.99917C10.4421 4.99928 10.8661 5.17503 11.1787 5.48774C11.4913 5.80046 11.6668 6.22453 11.6667 6.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsBank);
export default __webpack_public_path__ + "static/media/bxs-bank.675dee3990c1a772a4dd5872a9005f31.svg";
export { ForwardRef as ReactComponent };